/**
 * @file Print
 */

import axios from 'axios';


/**
 * Print component
 */
const vPrint = () => {
    const printForm = document.querySelector('.v-alert__print-form');

    if (!printForm) {
        return;
    }

    const printBtn = printForm.querySelector('button.v-alert__menu-btn--print');

    printBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const logged      = printForm.getAttribute('data-logged');

        if (logged === 'true') {
            window.print();
        }

        const endpoint     = printForm.getAttribute('action');
        const token        = printForm.querySelector('input[name="_token"]').value;
        const submissionId = printForm.getAttribute('data-submission-id');

        // hit endpoint to log print attempt
        const axiosInstance = axios.create({
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });


        axiosInstance.post(endpoint, {
            id: submissionId,
            _token: token,
        })
            .then((response) => {
                if (response.data.success) {
                    printForm.setAttribute('data-logged', 'true');
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                window.print();
            });

    });
};

export default vPrint;
